import { Component, OnInit } from '@angular/core';
import { ServiceMethods } from '@feathersjs/feathers';
import { MailList } from 'src/app/models/mail-list';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Email } from 'src/app/models/email';
import { Site } from 'src/app/models/site';
import { Observable, from, merge, combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';

// import { Quill } from 'quill';

@Component({
  selector: 'app-email-details',
  templateUrl: './email-details.component.html',
  styleUrls: ['./email-details.component.scss']
})
export class EmailDetailsComponent implements OnInit {
  id: string;
  emailService: ServiceMethods<MailList>;
  siteService: ServiceMethods<Site>;
  mailListService: ServiceMethods<MailList>;
  sendEmailService: ServiceMethods<any>;
  uploadUrlService: ServiceMethods<any>;
  loading: boolean;
  emailForm: FormGroup;
  testEmailAddress: FormControl;

  siteList$: Observable<Site[]>;
  maillistList$: Observable<MailList[]>;
  siteList: Site[] = [];
  maillistList: MailList[] = [];

  constructor(
    public translate: TranslateService,
    private feathers: VznFeathersService<any>,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.translate = translate;
    this.emailService = this.feathers.service('emails');
    this.siteService = this.feathers.service('sites');
    this.sendEmailService = this.feathers.service('send-email');
    this.mailListService = this.feathers.service('maillists');
    this.uploadUrlService = this.feathers.service('upload-url');

    this.testEmailAddress = new FormControl('');
    this.emailForm = this.formBuilder.group({
      name: '',
      subject: '',
      fromName: '',
      fromEmail: '',
      body: '',
      smsFrom: ['', [Validators.maxLength(11), Validators.pattern('[a-zA-Z]*')]],
      smsContent: '',
      siteId: null,
      maillistId: null,
      htmlCode: '',
      sendgridApiKey: '',
      sitePath: '',
      attachments: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.loading = true;

    this.siteList$ = from(this.siteService.find({
      query: {
        $paginate: false
      }
    }).then((siteList: Site[]) => this.siteList = siteList.map(x => new Site(x)))
    );

    this.maillistList$ = from(this.mailListService.find({
      query: {
        $paginate: false
      }
    }).then((maillistList: MailList[]) => this.maillistList = maillistList.map(x => new MailList(x)))
    );

    this.activatedRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
      this.id = paramMap.get('id');

      if (this.id === 'new') {
        this.loading = false;
      } else {
        combineLatest([this.maillistList$, this.siteList$]).subscribe(async _ => {
          const email: Email = new Email(await this.emailService.get(this.id));
          this.emailForm.patchValue(email);
          this.emailForm.controls.attachments = this.formBuilder.array(email.attachments || []);
          this.loading = false;
        });
      }
    });
  }

  siteForId = (id: string) => {
    const site: Site = (this.siteList || []).find(_site => _site._id === id);
    return site?.name;
  }

  maillistForId = (id: string) => {
    const maillist: MailList = (this.maillistList || []).find(_maillist => _maillist._id === id);
    return maillist?.name;
  }

  get siteLink() {
    return `${window.location.origin}/${this.emailForm.value.sitePath}`
  }

  get emailId() {
    return this.id === 'new' ? 'emailId' : this.id;
  }

  get title() {
    let title: string;
    if (this.id === 'new') {
      title = this.translate.instant('NEW-MAILERS.TITLE');
    } else {
      title = this.translate.instant('NEW-MAILERS.EDIT-TITLE');
    }

    return title;
  }

  async onSubmit() {
    const submitValue = {
        ...this.emailForm.value,
        attachments: this.emailForm.controls.attachments.value
    }

    if (this.id === 'new') {
      await this.emailService.create(submitValue);
    } else {
      await this.emailService.patch(this.id, submitValue);
    }
    this.router.navigate(['/email-table']);
  }

  onCodeChanged(code) {
    console.log(code);
  }

  sendEmail(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      data: { title: this.translate.instant('NEW-MAILERS.ALERT-SEND-TITLE'), body: this.translate.instant('NEW-MAILERS.ALERT-SEND-DESC') }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        this.sendEmailService.create({
          emailId: this.id
        });
        this.router.navigate(['/email-table']);
      }
    });
  }

  // TODO : yonatan
  sendPreviewEmail() {
    this.sendEmailService.create({
      emailId: this.id,
      previewEmail: this.testEmailAddress.value
    });
  }

}
